import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { Tile } from '../../core/Tile';

export class StandardProductsMenuView extends React.Component {

    render() {
        return (
            <div className="view">
                <ImageTitle text='Standard Products' />
                <div className='tile-container'>
                    <Tile title='Standard Products' onClick={() => window.Router.setRoute('/standard-products/all')} />
                    <Tile title='Invalid Pricing' onClick={() => window.Router.setRoute('/standard-products/pricing/invalid')} />
                    <Tile title='Pouch Types' onClick={() => window.Router.setRoute('/standard-products/pouch-types')} />
                    <Tile title='Settings' onClick={() => window.Router.setRoute('/standard-products/settings')} />
                    <Tile title='Health' onClick={() => window.Router.setRoute('/standard-products/health')} />

                    
                </div>
            </div>
        );
    }
}
